module.exports = __webpack_public_path__ + "img/img_bj_brand@3x.87125d4b.png";